import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { PARAMS } from '../../../contants/PARAMS';
import { ParameterService } from '../../../services/parameter.service';
import { AlertService } from '../../../services/alert.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BUDGET_TYPES } from '../../../contants/BUDGET_TYPES';

@Component({
  selector: 'ztsi-budget-type-picker',
  templateUrl: './ztsi-budget-type-picker.component.html',
  styleUrls: ['./ztsi-budget-type-picker.component.css'],
  providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiBudgetTypePickerComponent),
			multi: true
		}
	]
})
export class ZtsiBudgetTypePickerComponent implements ControlValueAccessor {
	types: string[] = BUDGET_TYPES;

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _parameterService: ParameterService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._parameterService.getCachedSystemParameterArray<string>(PARAMS.BUDGET_TYPES, 3600).subscribe(response => {
			if (response.length != undefined && response.length > 0) {
				this.types = response;
				this.types.sort();
			}
			else {
				console.log('Unable to load budget type selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-budget-type-picker/ztsi-budget-type-picker.component.ts